import { css } from 'linaria';

export const axisPointsContainer = css`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  margin-bottom: 32px;
`;

export const axisPointName = css`
  && {
    display: block;
    margin-bottom: 12px;
  }
`;

export const axisPointWrapper = css`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const axisPoint = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 20px;
    border: 1px solid var(--control-secondary);
    border-radius: var(--rounding-m);
  }
`;

export const activeAxisPoint = css`
  && {
    border: 2px solid var(--control-primary);
  }
`;

export const inactiveAxisPoint = css`
  && {
    background: repeating-linear-gradient(
      -45deg,
      var(--background-secondary) 6px,
      var(--background-secondary) 12px,
      var(--control-minor) 13px,
      var(--control-minor) 14px
    );
    pointer-events: none;

    p {
      color: #b0b0b0;
    }
  }
`;
